<app-resource-details-info
    #infoComp
    [resource]="resource"
    [user]="user"
    [customer]="customer"
    [resourceItems]="resourceItems"
    [resourceCategories$]="resourceCategories$"
    [resourceTags$]="resourceTags$"
    [resourceType]="ResourceTypes.parentType(resource.type_id)"
    [occasionDates]="occasionDates"
    [resourceActionBtn]="resourceActionBtn"
    [actionBtnTemplate]="actionBtnTemplate"
    resourceLabel="Event"
    i18n-resourceLabel
>
    <ng-container itemsHeader>
        <h4 class="mb-0 mt-0">
            {{ resource.title }}
        </h4>
    </ng-container>
    <span actionBtnLabel i18n="@@enroll">Enroll</span>
    <span managerLabel i18n="@@tutor">Tutor</span>
    <span resCodeLabel i18n>Event code</span>
    <ng-container resourceSmallDetails>
        <div class="details-elem">
            <div class="pre">
                <mat-icon>{{ subEventType.icon }}</mat-icon>
                <div class="pre" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
                    <span>{{ mainEventType.title }}</span>
                    <span>{{ subEventType.title }}</span>
                    <span i18n>Event</span>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container extraInfo>
        <div fxLayout="column" *ngIf="resource.agenda">
            <div fxLayoutAlign="start center" fxLayoutGap="5px" fxLayout="row" class="title">
                <mat-icon>ballot</mat-icon>
                <span i18n>Agenda</span>
            </div>
            <div class="info" [innerHtml]="styleInnerHTML(resource.agenda)"></div>
        </div>
    </ng-container>
    <ng-container resourceDates>
        <app-occasions-dates-viewer
            [dates]="occasionDates"
            [canShowMore]="true"
            [timeZone]="resource.time_zone"
        ></app-occasions-dates-viewer>
    </ng-container>
    <ng-container resourceDuration>
        <div class="details-elem">
            <div class="pre">
                <mat-icon>timelapse</mat-icon>
                <span i18n="@@duration">Duration </span>
            </div>
            <span class="normal">{{ resource?.duration | formatIsoDuration : false }} </span>
        </div>
    </ng-container>
    <ng-container resourceType>
        <div fxLayoutAlign="center center">
            <div class="icon-wrapper">
                <mat-icon></mat-icon>
            </div>
            <span></span>
        </div>
    </ng-container>
    <ng-container resourceCircles>
        <div class="circle-item" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="icon-wrapper">
                <mat-icon matListIcon fontSet="klickdata" fontIcon="kd-icon-task"></mat-icon>
            </div>
            <span i18n>Event</span>
        </div>
        <div class="circle-item" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="icon-wrapper">
                <mat-icon>{{ ResourceTypes.getEventTypeByTypeId(resource.type_id).icon }}</mat-icon>
            </div>
            <span>{{ ResourceTypes.getEventTypeByTypeId(resource.type_id).title }}</span>
        </div>
        <div
            class="circle-item"
            matTooltip="Event is always available"
            i18n-matTooltip
            *ngIf="resource.always_available"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
        >
            <div class="icon-wrapper">
                <mat-icon>event_available</mat-icon>
            </div>
            <span i18n>Available</span>
        </div>
    </ng-container>
</app-resource-details-info>
<ng-template #actionBtnTemplate>
    <ng-container *ngIf="resource.opportunity_id">
        <button
            class="take"
            [disabled]="!checkCanJoiEvent()"
            (click)="checkCanJoiEvent() && joinEventDireclty()"
            mat-raised-button
        >
            <ng-container *ngIf="!checkCanJoiEvent()">
                <mat-icon>event_available</mat-icon>
                <span i18n>Joined</span>
            </ng-container>
            <ng-container *ngIf="checkCanJoiEvent()">
                <mat-icon>event_available</mat-icon>
                <span i18n>Join</span>
            </ng-container>
        </button>
    </ng-container>
    <ng-container *ngIf="!resource.opportunity_id">
        <button
            *ngIf="getResourceAvailablity(resource) | async; else shareLoadTemp; let eventJoin"
            (click)="takeEvent(resource, user, eventJoin)"
            class="take"
            mat-raised-button
        >
            <mat-icon>{{ eventJoin.icon }}</mat-icon>
            <span>{{ eventJoin.label }}</span>
        </button>
    </ng-container>
</ng-template>
<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
